import React, { useEffect, useRef } from "react";
import IconRow from "../IconRow/IconRow";
import "./Navbar.css";

function Navbar({ state, setState }) {
  const toggleButton = useRef(null);
  const navbarLinks = useRef(null);

  useEffect(() => {
    toggleButton.current.addEventListener("click", () => {
      navbarLinks.current.classList.toggle("active");
    });
  }, []);

  return (
    <nav className="navbar">
      <div className="top">
        <div className="brand-title"></div>
        <p ref={toggleButton} className="toggle-button">
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </p>
      </div>

      <div ref={navbarLinks} className="navbar-links">
        <ul>
          <li>
            <a href="/">Home</a>
          </li>
          <li>
            <a href="/stake">Stake</a>
          </li>
          <li>
            <a
              href="https://shop.ballerbearsnft.com/"
              rel="noreferrer"
              target="blank"
            >
              Merch
            </a>
          </li>
          <li>
            <a
              href="https://docs.ballerbearsnft.com/"
              rel="noreferrer"
              target="blank"
            >
              Docs
            </a>
          </li>
        </ul>

        <IconRow center={true} className="icon-row" />
      </div>
    </nav>
  );
}

export default Navbar;
